import axios from "axios";

import { setAxiosInterceptors } from "~/utils/axios/setAxiosInterceptors";

export default defineNuxtPlugin({
  dependsOn: ["platform", "amplify"],
  setup: () => {
    axios.defaults.timeout = 15000;
    axios.defaults.transitional = {
      clarifyTimeoutError: true, // to get more explicit timeout errors. see: https://github.com/axios/axios/issues/1543
    };

    setAxiosInterceptors(axios);
  },
});
